import React from 'react';
import PropTypes from 'prop-types';
import EacIcon from "../Icons/EacIcon";
import Button from "../Button/Button";
import ErrorIcon from "../Icons/ErrorIcon";

const StepOne = ({ handleStepOne, stepOneStatus }) => {

  const sendGANo = () => {
   try {
     window.dataLayer = window.dataLayer || [];
     window.dataLayer.push({
       "event": "tvcheck",
       "eventCategory": "tvcheck",
       "eventAction": "no",
       "eventLabel": "eac"
     });
     console.log("Send GA No Event");
   } catch (e) {}
  };

  return (
    <div className="eac-check__step">

      <div className="eac-check__step__title">
        Шаг 1
        {stepOneStatus === "error"
          ? <ErrorIcon />
          : null}
      </div>
      <div className="eac-check__step__subtitle">
        Пожалуйста, проверьте, есть&nbsp;ли на&nbsp;задней панели телевизора маркировка EAC
      </div>
      <div className="eac-check__content">
        <EacIcon />
      </div>

      <div className="eac-check__buttons">

        <Button className={"function__button"}
                text={"Да"}
                onClick={() => handleStepOne(true)} />

        <Button className={"function__button cancel__button"}
                text={"Нет"}
                onClick={() => {
                  sendGANo();
                  handleStepOne(false)
                }} />

      </div>
    </div>
  );

};

StepOne.propTypes = {};

export default StepOne;
